import React, { useState } from "react";
import { FiStar, FiBarChart2 } from "react-icons/fi";
import ClientNavbar from "../layout/ClientNavbar";
import { NavLink } from "react-router-dom";

/* ---------- STATIC FUND DATA (DEMO) ---------- */
const FUND_DATA = {
  name: "Axis Bluechip Fund",
  category: "Equity – Large Cap",
  riskLevel: "High",
  expenseRatio: "0.62%",
  nav: "₹52.34",
  lastUpdated: "15 Jan 2026",

  returns: {
    oneYear: "14.2%",
    threeYear: "18.6%",
    fiveYear: "16.9%",
  },

  riskMetrics: {
    beta: 1.02,
    sharpe: 0.78,
    stdDev: "13.5%",
  },

  holdings: [
    { name: "HDFC Bank", allocation: "9.8%" },
    { name: "ICICI Bank", allocation: "8.5%" }, 
    { name: "Reliance Industries", allocation: "7.2%" },
    { name: "Infosys", allocation: "6.4%" },
    { name: "L&T", allocation: "5.1%" },
  ],

  exitLoad: "1% if redeemed within 12 months. Nil thereafter.",

  taxNote: "Equity taxation: LTCG above ₹1 lakh taxed at 10%, STCG at 15%.",
};

export default function FundDetails() {
  const [optionType, setOptionType] = useState("Direct");
  const [planType, setPlanType] = useState("Growth");

  return (
    <>
      <ClientNavbar />
      <div className="page-content" style={{ background: "#f1f5f9" }}>
<style>{`
.btn-outline-custom {
    border: 1px solid rgba(15, 118, 110, 0.12);
    color: #0f766e;
    background: transparent;
}
`}</style>

          <div className="card shadow-sm p-4 mb-4">
            <h3 className="text-primary mb-2">Mutual Fund Details</h3>

            {/* Breadcrumb with custom link color */}
            <nav
              aria-label="breadcrumb"
              style={{ "--bs-breadcrumb-divider": "none" }}
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <NavLink to="/overview">Dashboard</NavLink> /
                </li>
                <li className="breadcrumb-item">
                  <NavLink to="/clientmutualfunds">Mutual Funds</NavLink> /
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Fund Details
                </li>
              </ol>
            </nav>
            </div>

            {/* Header */}
            <div className="card p-4 mb-4 shadow-sm">
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <h3 className="mb-1" style={{color: '#0d9488'}}>{FUND_DATA.name}</h3>
                  <p className="text-muted mb-0">
                    {FUND_DATA.category} • Risk: {FUND_DATA.riskLevel}
                  </p>
                  <small className="text-secondary" style={{color: "#28252a!important" }}>
                    NAV {FUND_DATA.nav} • Updated {FUND_DATA.lastUpdated}
                  </small>
                </div>

                <div className="d-flex gap-2">
                  <button className="icon-btn">
                    <FiStar />
                  </button>
                  <button className="icon-btn">
                    <FiBarChart2 />
                  </button>
                </div>
              </div>
            </div>

            {/* Option Type */}
            <div className="card p-4 mb-4 shadow-sm">
              <h5 className="mb-3">Plan Options</h5>
              <div className="d-flex gap-3">
                <select
                  value={optionType}
                  onChange={(e) => setOptionType(e.target.value)}
                  className="form-select w-auto"
                >
                  <option>Direct</option>
                  <option>Regular</option>
                </select>

                <select
                  value={planType}
                  onChange={(e) => setPlanType(e.target.value)}
                  className="form-select w-auto"
                >
                  <option>Growth</option>
                  <option>Dividend</option>
                </select>
              </div>
              <small className="text-muted mt-2 d-block">
                Cutoff time: Orders before 2 PM get same-day NAV
              </small>
            </div>

            {/* Performance */}
            <div className="card p-4 mb-4 shadow-sm">
              <h5 className="mb-3">Performance</h5>
              <div className="row text-center">
                <div className="col">
                  <h6>1 Year</h6>
                  <p className="text-success fw-semibold">
                    {FUND_DATA.returns.oneYear}
                  </p>
                </div>
                <div className="col">
                  <h6>3 Years</h6>
                  <p className="text-success fw-semibold">
                    {FUND_DATA.returns.threeYear}
                  </p>
                </div>
                <div className="col">
                  <h6>5 Years</h6>
                  <p className="text-success fw-semibold">
                    {FUND_DATA.returns.fiveYear}
                  </p>
                </div>
              </div>
            </div>

            {/* Risk Metrics */}
            <div className="card p-4 mb-4 shadow-sm">
              <h5 className="mb-3">Risk Metrics</h5>
              <ul className="list-unstyled mb-0">
                <li>Beta: {FUND_DATA.riskMetrics.beta}</li>
                <li>Sharpe Ratio: {FUND_DATA.riskMetrics.sharpe}</li>
                <li>Standard Deviation: {FUND_DATA.riskMetrics.stdDev}</li>
              </ul>
            </div>

            {/* Holdings */}
            <div className="card p-4 mb-4 shadow-sm">
              <h5 className="mb-3">Top Holdings</h5>
              {FUND_DATA.holdings.map((item, index) => (
                <div
                  key={index}
                  className="d-flex justify-content-between border-bottom py-2"
                >
                  <span>{item.name}</span>
                  <span>{item.allocation}</span>
                </div>
              ))}
            </div>

            {/* Exit Load & Tax */}
            <div className="card p-4 mb-4 shadow-sm">
              <h5 className="mb-2">Exit Load</h5>
              <p>{FUND_DATA.exitLoad}</p>

              <h5 className="mb-2 mt-3">Taxation</h5>
              <p>{FUND_DATA.taxNote}</p>
            </div>

            {/* Actions */}
            <div className="card p-4 shadow-sm">
              <div className="d-flex gap-3">
                <button className="btn btn-sm btn-outline-custom">
                  Start SIP
                </button>
                <button className="btn btn-primary">
                  Invest Lumpsum
                </button>
              </div>
            </div>
          </div>
    </>
  );
}
